import * as yup from 'yup'

export const societyEntranceCreateSchema = yup
  .object({
    addressStreet: yup.string().required(),
    societyId: yup.string().required(),
  })
  .required()
